<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-09 14:57:44
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-25 15:26:36
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/contacts/index.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="container contactList" :class="(subItem.type == 'ENTERPRISES' || subItem.type == 'PRODUCT') ? 'bg-f5f5f5' : 'bg-fff'">
    <div class="searchBox"><van-search v-model="nameOrPhone" clearable @input="onSearch" :placeholder="searchPlaceHolder" /></div>
    <div style="background-color: #f5f5f5;height: 10px;"></div>
    <van-tabs @click="changeTab" v-model="tabIndex">
      <van-tab v-for="(item, index) in tabList" :key="index" :title="getTabList[index].name" :color='"#00c4c9"'>
        <div>
          <div class="newContactList" v-if="newContactList.length > 0">
            <div class="title">{{ $t('lang.t128') }}</div>
            <template v-for="(userInfo, userIndex) in newContactList">
              <userItemCheck :userInfo='userInfo' :key='userIndex' @refresh='refresh'></userItemCheck>
            </template>
          </div>
          <!-- 我关注(用户 机构 产品) -->
          <template v-if="item.type == 'FOLLOWER'">
            <!-- 首次加载中... -->
            <!-- <template v-if="!item.list.length && !item.flag">
                  <div style="margin-top: 30px;">
                    <firstLoading></firstLoading>
                  </div>
                </template> -->
            <div class="subTablist">
              <van-tabs @click="hadnleChangeSubTab" v-model="subTabIndex" title-active-color="#00c4c9" line-width="0">
                <van-tab v-for="(sItem, sIndex) in subTabList" :title="getSubTabList[sIndex].title">
                  <van-pull-refresh v-model="getItem.refreshing" @refresh="handlePullDownRefresh">
                    <!-- 释放即可刷新 -->
                    <template #loosing>
                      <div>{{ loosingText }}</div>
                    </template>
                    <!-- 初次加载中... -->
                    <template #loading>
                      <div>{{ loadingText }}</div>
                    </template>
                    <van-list v-model="getItem.loading" :finished="getItem.finished" :offset="100" :immediate-check="false" :loading-text="getItem.loadingText" :finished-text="getItem.finishText" @load="handleReachBottom">
                      <!-- 用户 -->
                      <template v-if="subItem.type == 'USER'">
                        <template v-if="item.list.length">
                          <userItem v-for="(item, index) in item.list" :key="index" :userInfo="item"></userItem>
                        </template>
                        <template v-if="!item.finishText && item.finished">
                          <nothing customClass="px-0" top="180px" :text="getText"></nothing>
                        </template>
                      </template>
                      <!-- 机构 -->
                      <template v-if="subItem.type == 'ENTERPRISES'">
                        <template v-if="item.list.length">
                          <commonEnterpriseItem v-for="(item, index) in item.list" customBoxClass="mt-11 mx-12" :key="index" :item="item"></commonEnterpriseItem>
                        </template>
                        <template v-if="!item.finishText && item.finished">
                          <nothing customClass="px-0" top="180px" :text="getText"></nothing>
                        </template>

                      </template>
                      <!-- 产品 -->
                      <template v-if="subItem.type == 'PRODUCT'">
                        <template v-if="item.list.length">
                          <common-product-item v-for="(item, index) in item.list" customBoxClass="mt-11 mx-12" :key="index" :item="item">
                          </common-product-item>
                        </template>
                        <template v-if="!item.finishText && item.finished">
                          <nothing customClass="px-0" top="180px" :text="getText"></nothing>
                        </template>

                      </template>
                    </van-list>
                  </van-pull-refresh>
                </van-tab>
              </van-tabs>
            </div>
          </template>
          <!-- 联系人 被关注 -->
          <template v-if="item.type != 'FOLLOWER'">
            <template v-if="item.list.length > 0">
              <div class="list">
                <van-index-bar>
                  <template v-for="(item, index) in item.list">
                    <van-index-anchor :index="item.key" />
                    <template v-for="(userInfo, userIndex) in item.arr">
                      <userItem :userInfo='userInfo'></userItem>
                    </template>
                  </template>
                </van-index-bar>
              </div>
            </template>
            <template v-if="!item.list.length && item.flag">
              <nothing customClass="px-0" top="180px" :text="getText"></nothing>
            </template>
          </template>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import userItem from './components/userItem.vue'
import userItemCheck from './components/userItemCheck.vue'
import enterPriseItem from './components/enterPriseItem.vue'
import commonEnterpriseItem from '@/components/common-enterprise-item.vue'
import commonProductItem from '@/components/common-product-item.vue'
import firstLoading from '@/components/firstLoading.vue'
import nothing from '@/components/nothing.vue'
import { getContactList, getWaitContactList, getEnterpriseList, followList } from '@/api/interNational'
import { GetQueryString } from '@/utils/utils'
export default {
  name: 'index',
  components: {
    userItem,
    userItemCheck,
    enterPriseItem,
    commonEnterpriseItem,
    commonProductItem,
    nothing,
    firstLoading,
  },
  computed: {
    subItem() {
      let subTabIndex = this.subTabIndex
      return this.subTabList[subTabIndex]
    },
    loosingText() {
      return `${this.$t('lang.t338')}`
    },
    loadingText() {
      return `${this.$t('lang.t337')}...`
    },
    searchPlaceHolder() {
      let index = this.tabIndex
      let item = this.tabList[index]
      let subTabIndex = this.subTabIndex
      let subTabItem = this.subTabList[subTabIndex]
      if (item.type == 'FOLLOWER') {
        switch (subTabItem.type) {
          case 'USER':
            return this.$t('lang.t137')
          case 'ENTERPRISES':
            return this.$t('lang.t327')
          case 'PRODUCT':
            return this.$t('lang.t305')
          default:
            return this.$t('lang.t137')
        }
      } else {
        return this.$t('lang.t137')
      }
      // return this.form.type == `ENTERPRISE` ? this.$t('lang.t327') : this.$t('lang.t137')
    },
    getText() {
      return this.$t('lang.t285')
    },
    getTabList() {
      return [
        {
          name: this.$t('lang.t127'),
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
        },
        {
          name: this.$t('lang.t133'),
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
        },
        {
          name: this.$t('lang.t134'),
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
        },
        {
          name: this.$t('lang.t135'),
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
        },
        {
          name: this.$t('lang.t136'),
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
        },
      ]
    },
    getSubTabList() {
      return [
        {
          title: this.$t('lang.t334'),
          // title: '用户',
          type: 'USER',
        },
        {
          title: this.$t('lang.t221'),
          // title: '机构',
          type: 'ENTERPRISES',
        },
        {
          title: this.$t('lang.t252'),
          // title: '产品',
          type: 'PRODUCT',
        },
      ]
    },
    getItem() {
      let index = this.tabIndex
      return this.tabList[index]
    },
  },
  data() {
    return {
      form: {
        // nameOrPhone: '',
        // type: 'CONTACT',
        type: 'CONTACT',
      },
      params: {
        name: '',
      },
      list: [],
      newContactList: [],
      enterList: [],
      nameOrPhone: '',
      // 一级tab
      tabList: [
        {
          name: '联系人',
          type: 'CONTACT',
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
          list: [],
          total: 0, // 总条数
          pages: 0, // 总页数
          pageSize: 10,
          pageNum: 1,
          isHasPage: false, // 是否有分页
          loading: false, //  控制数据的加载，false 代表没有正在刷新，true 代表正在刷新
          finished: false, // 是否已加载完成，加载完成后不再触发load事件
          refreshing: false, // 下拉状态是否处于加载中状态
          flag: false, // 暂无数据的开关
          index: 0,
        },
        {
          name: '我关注',
          type: 'FOLLOWER',
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
          list: [],
          total: 0, // 总条数
          pages: 0, // 总页数
          pageSize: 10,
          pageNum: 1,
          isHasPage: false, // 是否有分页
          loading: false, //  控制数据的加载，false 代表没有正在刷新，true 代表正在刷新
          finished: false, // 是否已加载完成，加载完成后不再触发load事件
          refreshing: false, // 下拉状态是否处于加载中状态
          flag: false, // 暂无数据的开关
          index: 1,
        },
        {
          name: '被关注',
          type: 'LIKE_ME',
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
          list: [],
          total: 0, // 总条数
          pages: 0, // 总页数
          pageSize: 10,
          pageNum: 1,
          isHasPage: false, // 是否有分页
          loading: false, //  控制数据的加载，false 代表没有正在刷新，true 代表正在刷新
          finished: false, // 是否已加载完成，加载完成后不再触发load事件
          refreshing: false, // 下拉状态是否处于加载中状态
          flag: false, // 暂无数据的开关
          index: 2,
        },
        {
          name: '消息',
          type: 'IM',
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'),
          list: [],
          total: 0, // 总条数
          pages: 0, // 总页数
          pageSize: 10,
          pageNum: 1,
          isHasPage: false, // 是否有分页
          loading: false, //  控制数据的加载，false 代表没有正在刷新，true 代表正在刷新
          finished: false, // 是否已加载完成，加载完成后不再触发load事件
          refreshing: false, // 下拉状态是否处于加载中状态
          flag: false, // 暂无数据的开关
          index: 3,
        },
        {
          name: '未处理请求',
          type: 'request',
          loadingText: `${this.$t('lang.t337')}...`,
          finishText: this.$t('lang.t306'), // 没有更多了
          list: [],
          total: 0, // 总条数
          pages: 0, // 总页数
          pageSize: 10,
          pageNum: 1,
          isHasPage: false, // 是否有分页
          loading: false, //  控制数据的加载，false 代表没有正在刷新，true 代表正在刷新
          finished: false, // 是否已加载完成，加载完成后不再触发load事件
          refreshing: false, // 下拉状态是否处于加载中状态
          flag: false, // 暂无数据的开关
          index: 4,
        },
      ],
      tabIndex: 0,
      // 二级tab列表
      subTabList: [
        {
          // title: this.$t('lang.t334'),
          title: '用户',
          type: 'USER',
        },
        {
          // title: this.$t('lang.t221'),
          title: '机构',
          type: 'ENTERPRISES',
        },
        {
          // title: this.$t('lang.t252'),
          title: '产品',
          type: 'PRODUCT',
        },
      ],
      // 二级tab索引
      subTabIndex: 0, // 当前选中的子选项卡的索引值，默认为0，即第一个子选项卡。
      // 2024-06-05结束
      isFollowEnterprise: false,
    }
  },
  watch: {
    '$route.query'(val) {
      this.form.type = val.type
      this.tabIndex = this.tabList.filter((v) => v.type == this.form.type)[0].index
      this.getData()
      this.getWaitList()
    },
    subTabIndex: {
      handler() {
        if (this.subItem.type == 'USER') {
          this.$eventBus.$emit('setBgColor', 'bg-fff')
        } else {
          this.$eventBus.$emit('setBgColor', 'bg-f5f5f5')
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.form.type = GetQueryString('type') || 'CONTACT'

    console.log(this.form)
    this.$eventBus.$on('setEnterpriseIndex', this.handleSetEnterpriseIndex)
    if (!this.isFollowEnterprise) {
      this.initData()
    }
    this.$eventBus.$on('refreshLocael', this.initData)
  },
  beforeDestroy() {
    this.$eventBus.$off('setEnterpriseIndex', this.handleSetEnterpriseIndex)
    this.$eventBus.$off('refreshLocael', this.initData)
  },
  methods: {
    initData() {
      this.isFollowEnterprise = true
      let index = this.tabIndex
      let item = this.tabList[index]
      item.list = []
      item.pageNum = 1
      this.getData()
      this.getWaitList()
    },
    handleSetEnterpriseIndex() {
      console.log(':1111')
      this.subTabIndex = 1
      this.tabIndex = 1
      let index = this.tabIndex
      let item = this.tabList[index]
      item.list = []
      item.pageNum = 1
      this.getData()
    },
    // 上拉加载
    handleReachBottom() {
      console.log('上拉加载1111111111')
      let index = this.tabIndex
      let item = this.tabList[index]
      console.log('item=====', item)
      console.log('上拉加载')
      console.log(`output->item.pageNum`, item.pageNum)
      if (item.pageNum < item.pages) {
        item.pageNum++
        setTimeout(() => {
          this.getData().finally(() => {
            item.loading = false
          })
        }, 800)
      } else {
        item.finished = true
      }
    },
    // 下拉刷新
    handlePullDownRefresh() {
      let index = this.tabIndex
      let item = this.tabList[index]
      setTimeout(() => {
        item.pageNum = 1
        item.list = []
        item.refreshing = false
        item.finished = false // 重新加载
        this.getData()
        if (!item.refreshing) {
          let title = this.$t('lang.t336')
          this.$toast.success(title)
        }
      }, 1000)
    },

    refresh() {
      let index = this.tabIndex
      let item = this.tabList[index]
      item.pageNum = 1
      item.list = []
      item.finished = false // 重新加载
      this.getData()
      this.getWaitList()
    },
    async getWaitList() {
      const { data } = await getWaitContactList()
      console.log(data)
      this.newContactList = data.filter((v) => v.requestStatus == 'PENDING_AGREE')
    },
    getMyFollowData() {
      let index = this.tabIndex
      let subTabIndex = this.subTabIndex
      let subItem = this.subTabList[subTabIndex]
      let item = this.tabList[index]
      item.loading = true
      let params = {}
      // 展会/会议/展商/产品/展品
      params = {
        interest: true,
        language: '',
        pageNum: item.pageNum,
        pageSize: item.pageSize,
        relationId: '',
        type: subItem.type,
        keyword: this.nameOrPhone,
      }
      followList({}, params)
        .then((res) => {
          console.log('res===followList', res)
          const { data } = res.data
          console.log('data==', data)
          item.total = data.total
          item.list = item.pageNum == 1 ? [...data] : [...item.list, ...data]
          item.pages = res.data.pages
          item.pageNum = res.data.pageNum
          // 追加完成后关闭loading
          item.loading = false
          item.loadingText = this.$t('lang.t337')
          item.finishText = item.list.length ? this.$t('lang.t306') : ''
        })
        .catch((err) => {
          if (item.pageNum > 1) {
            item.pageNum--
            item.finished = false
          }
        })
        .finally(() => {})
    },
    async getData() {
      let index = this.tabIndex
      let item = this.tabList[index]
      let subTabIndex = this.subTabIndex
      let subTabItem = this.subTabList[subTabIndex]
      let params = {}
      if (item.type != 'FOLLOWER') {
        item.flag = false
        params = {
          ...this.form,
          nameOrPhone: this.nameOrPhone,
          sceneType: subTabItem.type == 'ENTERPRISES' ? subTabItem.type : '',
        }
        try {
          const { data } = await getContactList({}, params)
          const merged = {}
          if (!!data) {
            data.forEach((item) => {
              const { initials } = item
              if (!merged[initials]) {
                merged[initials] = { key: initials, arr: [] }
              }
              merged[initials].arr.push(item)
            })
            item.list = Object.values(merged)
          } else {
            item.list = []
          }
        } catch (error) {
        } finally {
          item.flag = true
        }
      } else {
        console.log('用户 机构 产品')
        this.getMyFollowData()
      }
      // }
    },

    onSearch() {
      let index = this.tabIndex
      let item = this.tabList[index]
      item.pageNum = 1
      item.list = []
      this.getData()
    },
    // tab 改变
    changeTab(index) {
      let item = this.tabList[index]
      if (item.type == 'FOLLOWER') {
        item.refreshing = false
        item.finished = false // 重新加载
      }
      // if (this.tabIndex === index) return console.log("不可重复点击")
      this.tabIndex = index
      console.log('eeeee=changeTab', index)
      // 重置参数开始
      this.nameOrPhone = ''
      this.subTabIndex = 0
      item.pageNum = 1
      item.list = []

      // 重置参数结束
      this.form.type = item.type
      if (item.type == 'IM') {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        let imUrl = process.env.VUE_APP_IM_BASE_URL + `/#?uid=${userInfo.imUid}&language=${this.$i18n.locale}`
        location.href = imUrl
        return false
      }
      if (item.type == 'request') {
        this.$router.push('/mini-h5/index/requestList')
        return false
      }
      this.getData()
    },
    hadnleChangeSubTab(subTabIndex) {
      console.log(subTabIndex)
      // if(this.subTabIndex == subTabIndex) return console.log("不可重复点击")
      let subType = this.subTabList[subTabIndex].type
      console.log('subType===', subType)
      this.subTabIndex = subTabIndex
      let index = this.tabIndex
      let item = this.tabList[index]
      item.refreshing = false
      item.finished = false // 重新加载
      item.pageNum = 1
      item.list = []
      this.getData()
    },
  },
}
</script>

<style lang="less">
.bg-fff {
  background-color: #fff;
}

.bg-f5f5f5 {
  background-color: #f5f5f5;
}

.container {
  .van-tabs__line {
    background-color: #00c4c9;
  }

  &.contactList {
    .van-tabs__wrap {
      overflow-x: auto;
    }

    .van-tab {
      margin-right: 10px;
      flex: none;
    }

    .van-cell {
      padding: 0;
      height: 40px;
      background: transparent;

      .van-field__body {
        height: 100%;
      }

      .van-field__left-icon {
        display: flex;
        align-items: center;
      }

      .van-field__control {
        height: 100% !important;
        padding: 14px 0;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.container {
  // min-height: 100vh;
  text-align: left;

  .searchBox {
    // margin-bottom: 10px;
  }

  .noContainer {
    height: 80vh;
    background: #fff;
    position: relative;

    .noContentBox {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;

      .noContentImg {
        width: 155px;
        height: 155px;
      }

      .word {
        color: #9e9e9e;
        font-size: 14px;
      }
    }
  }

  .list {
    height: 100vh;
    background: #fff;
    position: relative;
  }

  .newContactList {
    background: #fff;

    .title {
      font-size: 13px;
      color: #9e9e9e;
      margin-bottom: 10px;
      padding: 0 12px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .van-tabs__wrap {
  background-color: #fff;
  padding: 0 16px;
}

.subTablist {
  padding-bottom: 20px;
}
</style>